// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"fd84429a","287":"fdf96e91","301":"642b9012","559":"8d59de7c","677":"fcf336a6","924":"4d6cbe91"}[chunkId] + ".chunk.css";
};